const ProductDetail = {
  path: '/catalog/product-detail/:slug',
  name: 'product-detail',
  component: () => import('../../views/Product/product-detail.vue'),
};

module.exports = {
  ProductDetail,
};
